import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center"
    },
    tabBar: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        shadowRadius: 12,
        elevation: 6,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25
    },
    tabItem: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    activeTabItem: {
    },
    iconContainer: {
        justifyContent: "center",
        alignItems: "center"
    }
});
export default stylesheet;
